export enum ChequeDirection {
  IN = "in",
  OUT = "out",
}

export const ChequeDirectionInfo = {
  [ChequeDirection.IN]: { code: "in", name: "In" },
  [ChequeDirection.OUT]: { code: "out", name: "Out" },
} as const;

export const getChequeDirectionCode = (value: ChequeDirection): string =>
  ChequeDirectionInfo[value].code;
export const getChequeDirectionName = (value: ChequeDirection): string =>
  ChequeDirectionInfo[value].name;
